export default function mask(){
    let cpfs = document.querySelectorAll("#cpf");
    let ceps = document.querySelectorAll("#cep");
    let tels = document.querySelectorAll("#tel");
    let phones = document.querySelectorAll("#phone");
    let dates = document.querySelectorAll("#date");
    let ages = document.querySelectorAll("#age");
    let luckys = document.querySelectorAll("#lucky");

    $('#crm').mask('AA/000000', {
        translation: {
            'A': { pattern: /[A-Za-z]/ }, 
            '0': { pattern: /[0-9]/ }
        }
    });

    cpfs.forEach(cpf => {
        $(cpf).mask('000.000.000-00', {reverse: true});
    }); 

    ceps.forEach(cep => {
        $(cep).mask('00000-000');
    });

    tels.forEach(tel => {
        $(tel).mask('(00) 0000-0000');
    });

    phones.forEach(phone => {
        $(phone).mask('(00) 00000-0000');
    }); 

    dates.forEach(date => {
        $(date).mask('00/00/0000');
    });  
 
    ages.forEach(age => {
        $(age).mask('999');
    });

    luckys.forEach(lucky => {
        $(lucky).mask('999999999999999');
    }); 
}